export const DELIVERY_CHARGE_BELOW_FIVE_THOUSAND = 100;
export const DELIVERY_CHARGE_BETWEEN_FIVE_AND_TEN_THOUSAND = 50;
export const PRICE_THRESHOLD_FOR_FIFTY_DELIVERY_CHARGE = 5000;
export const PRICE_THRESHOLD_FOR_FREE_DELIVERY = 10000;
export const minValueForOrderToProceed = 50;
export const EstoreAdminToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoidmVuZG9yIiwidXNlcklkIjoiNjc1ODc3YTk5ODQzNmRlODQyNzg5OWQ4IiwiaWF0IjoxNzQ1ODI3NTUwfQ.IumnzrbLjTEg2w074accS1UPrMkgfw1oq08dJr-BGY8";
